import axios from "axios";

export const PartnerApi = axios.create({
  baseURL: process.env.REACT_APP_PARTNER_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
